'use client';

import { useEffect } from 'react';

import useMobileStore from '@/store/mobileStore';
import { useSpaceStore } from '@/store/peyong';
import { appToGetString } from '@/utils/js/webView';

export default function PyeongConfig() {
  const { setSquareMeter } = useSpaceStore();
  const { isWebView } = useMobileStore();

  useEffect(() => {
    if (isWebView) {
      appToGetString('isPyeong'); // isPeyong 이벤트 선언

      const handleMessage = (event: MessageEvent) => {
        try {
          const data = event.data;

          // console.log('Received message3:', data);

          // Y면 앱 최초 실행
          if (data === 'Y') {
            setSquareMeter(false);
          } else {
            setSquareMeter(true);
          }

          // 메시지 처리 로직
        } catch (error) {
          console.error('Error processing message:', error);
        }
      };

      window.addEventListener('message', handleMessage);

      // Android location 함수 설정
      (window as any).isPyeong = (message: string) => {
        // console.log('Received message4:', message);
        handleMessage({ data: message } as MessageEvent);
      };

      return () => {
        window.removeEventListener('message', handleMessage);
        delete (window as any).isPyeong;
      };
    }
  }, []);

  return <></>;
}
